import type { WebhookRequestTriggerStatus } from "@app/types/assistant/triggers";
import { Chip } from "@dust-tt/sparkle";
import type { ComponentProps } from "react";
import { useTranslation } from "react-i18next";

interface WebhookRequestStatusBadgeProps {
  status: WebhookRequestTriggerStatus;
}

export function WebhookRequestStatusBadge({
  status,
}: WebhookRequestStatusBadgeProps) {
  const { t } = useTranslation();
  const statusConfig: Record<
    WebhookRequestTriggerStatus,
    { label: string; variant: ComponentProps<typeof Chip>["color"] }
  > = {
    workflow_start_succeeded: {
      label: t("builder.webhookStatusSucceeded", "Succeeded"),
      variant: "success",
    },
    workflow_start_failed: {
      label: t("builder.webhookStatusFailed", "Failed"),
      variant: "warning",
    },
    not_matched: {
      label: t("builder.webhookStatusNotMatched", "Not Matched"),
      variant: "info",
    },
    rate_limited: {
      label: t("builder.webhookStatusRateLimited", "Rate Limited"),
      variant: "warning",
    },
  };

  const config = statusConfig[status];

  return (
    <Chip
      color={config.variant}
      size="xs"
      label={config.label}
      className="select-none"
    />
  );
}
